<template>
  <div id="the-good">
    <b-container class="the-good-container">
      <div class="gitg-logo-container" v-if="global.screenWidth > 992">
        <img
          class="gitg-logo"
          :src="
            require('@/assets/images/galleries/sam/thegood/Sam-Kirk-The-Good-Logo.jpg')
          "
        />
      </div>
      <div class="good-content">
        <div class="header-align">
          <Header title="The Good" :alignBarStart="global.screenWidth > 992" />
        </div>
        <img
          v-if="global.screenWidth <= 992"
          class="gitg-logo"
          :src="
            require('@/assets/images/galleries/sam/thegood/Sam-Kirk-The-Good-Logo.jpg')
          "
        />

        <p>
          Center on Halsted is the Midwest's most comprehensive community center dedicated
          to advancing community and securing the health and well-being of the Lesbian, Gay,
          Bisexual, Transgender and Queer (LGBTQ) people of Chicagoland. More than 1,000
          community members visit the Center every day, located in the heart of Chicago's
          Lakeview neighborhood.
        </p>
        <ImageGallery
          style="margin-top: 40px; margin-bottom: 40px"
          :data="[
            require('@/assets/images/galleries/sam/thegood/center-on-01.jpg'),
            require('@/assets/images/galleries/sam/thegood/center-on-02.jpg'),
            require('@/assets/images/galleries/sam/thegood/center-on-03.jpg')
          ]"
          :idString="'thegood'"
        />
        <p>
          To learn more about Center on Halsted, visit:
          <a href="https://centeronhalsted.org/" target="_blank" style="color: #ce0e2d">
          Centeronhalsted.org.
          </a>
        </p>
      </div>
    </b-container>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import Header from "@/components/global/Header";
import { mapState } from "vuex";
export default {
  name: "TheGood",
  components: {
    ImageGallery,
    Header,
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
#the-good {
  padding-bottom: 100px;
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-good-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    @media (max-width: 1050px) {
      flex-direction: column;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .gitg-logo-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1;
    height: 100%;
    margin-top: -150px;
    @media (max-width: 1050px) {
      align-items: center;
      margin-top: 0;
    }
  }
  .header-align {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 40px;
    height: 100px;
    width: auto;
    @media (max-width: 1050px) {
      justify-content: center;
      margin-bottom: 0;
    }
  }
  .gitg-logo {
    width: 298px;
    max-width: 90%;
    object-fit: contain;
    @media (max-width: 1050px) {
      margin-bottom: 37px;
    }
  }
  .good-content {
    width: 670px;
    max-width: 75%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media (max-width: 1050px) {
      align-items: center;
      width: 100%;
      max-width: 100%;
    }
  }

  p,
  span {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: start;
    line-height: 23px;
    @media (max-width: 1050px) {
      text-align: center;
    }
  }

  a {
    color: $red;
    text-decoration: none;
  }
}
</style>
